export default __webpack_public_path__ + "static/media/PowerGrotesk-HeavyItalic.b8c130a2.otf";